import { Component, OnInit, ViewChild } from '@angular/core';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { MonthDays } from 'src/app/models/new-calender-models/month-days';
import { CalenderWeek } from '../../models/calender-report/calender-week';
import { MonthItem } from 'src/app/models/new-calender-models/month-item';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalenderReportType } from 'src/app/enum/calender-report-type';
import { CalenderReportRequest } from '../../models/calender-report/calender-report-request';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';

@Component({
  selector: 'app-report-calender',
  templateUrl: './report-calender.component.html',
  styleUrls: ['./report-calender.component.css'],
})
export class ReportCalenderComponent implements OnInit {
  constructor(
    private calendarService: NewCalendarService,
    private logger: LoggerService,
    private modalService: NgbModal,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.loading = true;
    this.backEndRequest = new CalenderReportRequest();

    this.reportType = Object.keys(CalenderReportType)
      .filter((key) => !isNaN(Number(CalenderReportType[key])))
      .map((key) => ({ value: CalenderReportType[key], name: key }));

    this.drugGroups = [];
    this.getDrugGroup();
    this.getSearchEntity();

    this.insurances = [];
    this.getInsurances();

    this.thisMonth = this.clearCalender(
      this.calendarService.getToDayMonthJalali()
    );
    this.year = this.thisMonth.year;
    this.months = this.calendarService.getMonth(true);
    this.searchRequestModel = new PCSearchRequestModel();

    this.weeks = [];
    this.renderWeek();

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });
  }

  public drugSearchForm: FormGroup;
  public activeSearch: boolean = false;
  public searchData?: PCTableInputModel;
  public searchPaging?: TabelPaging;
  public searchRequestModel: PCSearchRequestModel;
  public searchFields: any[] = [];

  public thisMonth: MonthDays;
  public weeks: CalenderWeek[];
  public months: MonthItem[];

  public year: number = 1403;
  public inputYear?: number = undefined;
  public outputYear?: number = undefined;

  public loading: boolean = false;
  public modalIsOpen: boolean = false;
  public renderBackEndActive: boolean = false;

  public backEndRequest: CalenderReportRequest;

  public reportType: any[];
  public drugGroups: any[];
  public insurances: any[];

  public firstIcon: string = 'fa-solid fa-cart-plus';
  public fistClass: string = 'calender-color-buy';

  public secondIcon: string = 'fa-solid fa-shop';
  public secondClass: string = 'calender-color-sale';
  public searchWithDrug: boolean = true;

  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;

  public getDrugGroup() {
    try {
      const url = `DrugGroup?pageNumber=1&pageSize=10000&paging=false&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (result.data != undefined) {
              this.drugGroups = result.data.map((current) => ({
                id: current.id,
                value: current.title,
              }));
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.checkFinishGetInitialValues();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.checkFinishGetInitialValues();
        },
        () => {
          this.checkFinishGetInitialValues();
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getInsurances() {
    try {
      const url = `Insurance?pageNumber=1&pageSize=10000&paging=false&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            if (result.data != undefined) {
              this.insurances = result.data.map((current) => ({
                id: current.id,
                value: current.persianName,
              }));
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.checkFinishGetInitialValues();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.checkFinishGetInitialValues();
        },
        () => {
          this.checkFinishGetInitialValues();
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkFinishGetInitialValues() {
    if (this.insurances.length > 0 && this.drugGroups.length > 0) {
      this.loading = false;
    }
  }

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSearch) {
          this.searchDrug(value);
        } else {
          this.activeSearch = true;
        }
      });
  }

  public searchDrug(drugName: string): void {
    try {
      if (drugName == null || drugName.length < 3) {
        return;
      }

      const url = `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      if (this.searchFields == null || this.searchFields.length == 0) {
        this.getSearchEntity();
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.searchRequestModel.orderBy,
              this.searchRequestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);

            setTimeout(() => {
              if (this.modalIsOpen == false) {
                this.modalIsOpen = true;
              }
            }, 20);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.backEndRequest.drugName!);
        break;
      case 'Paging':
        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.backEndRequest.drugName!);
        break;
      case 'PageSize':
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.backEndRequest.drugName!);
        break;
      case 'SelectItem':
        this.selectDrug(event.data);
        this.modalIsOpen = false;
        break;
      default:
        break;
    }
  }

  public selectDrug(eventData: any) {
    this.backEndRequest.drugName = eventData.drugBrandName;
    this.backEndRequest.drugId = eventData.id;
    this.activeSearch = false;
  }

  public renderWeek() {
    let weekNumber = 1;
    this.weeks = [];
    let thisMonth = this.months[this.thisMonth.monthNumber - 1];
    thisMonth.inputValue = 0;
    thisMonth.outputValue = 0;
    for (let index = 0; index < 6; index++) {
      let output = 0;
      let input = 0;
      let isWeekActive = false;

      for (let day = 0; day < 7; day++) {
        const thisDay = this.thisMonth.days[index * 7 + day];

        let thisInputCount = 0;
        if (thisDay.inputValue != undefined) {
          thisInputCount = parseInt(thisDay.inputValue.toString(), 10);
        }

        let thisOutputCount = 0;
        if (thisDay.outputValue != undefined) {
          thisOutputCount = parseInt(thisDay.outputValue.toString(), 10);
        }

        if (thisDay.dayOfMonth !== 0) {
          input += thisInputCount;
          thisMonth.inputValue += thisInputCount;

          output += thisOutputCount;
          thisMonth.outputValue += thisOutputCount;

          isWeekActive = true;
        }
      }

      let newWeek = new CalenderWeek(weekNumber, false, input, output);
      newWeek.isActive = isWeekActive;
      this.weeks.push(newWeek);
      if (isWeekActive) {
        weekNumber++;
      }
    }

    if (!this.renderBackEndActive) {
      thisMonth.inputValue = undefined;
      thisMonth.outputValue = undefined;
    }
    this.renderYear();
    this.getHoliday();
  }

  public renderYear() {
    this.inputYear = 0;
    this.outputYear = 0;
    this.months.forEach((element) => {
      if (element.inputValue != undefined) {
        this.inputYear! += element.inputValue;
      }
      if (element.outputValue != undefined) {
        this.outputYear! += element.outputValue;
      }
    });
    if (!this.renderBackEndActive) {
      this.inputYear = undefined;
      this.outputYear = undefined;
    }
  }

  public chooseMonth(selectedMonth: number) {
    this.loading = true;
    this.thisMonth = this.clearCalender(
      this.calendarService.getMonthDays(selectedMonth, this.year, true)
    );

    this.getHoliday();
    this.getBackendData();
  }

  public validate(): boolean {
    var result = true;

    if (this.backEndRequest.reportType == -1) {
      this.backEndRequest.reportTypeMessage = 'فیلد الزامی است';
      result = false;
    } else {
      this.backEndRequest.reportTypeMessage = undefined;
      if (
        this.backEndRequest.reportType == CalenderReportType.BuyAndSaleCount ||
        this.backEndRequest.reportType == CalenderReportType.BuyAndSalePrice ||
        this.backEndRequest.reportType == CalenderReportType.CollectiveSale
      ) {
        if (
          (this.backEndRequest.drugId == undefined ||
            this.backEndRequest.drugId == '') &&
          (this.backEndRequest.drugGroupId == undefined ||
            this.backEndRequest.drugGroupId == '')
        ) {
          this.backEndRequest.drugNameMessage =
            'یا نام دارو یا نام گروه دارویی را وارد کنید';
          this.backEndRequest.drugGroupNameMessage =
            'یا نام دارو یا نام گروه دارویی را وارد کنید';
          result = false;
        } else {
          let guidRegex = new RegExp(
            /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/
          );

          if (this.backEndRequest.drugGroupId?.match(guidRegex)) {
            this.backEndRequest.drugNameMessage = undefined;
            this.backEndRequest.drugGroupNameMessage = undefined;
          } else if (this.backEndRequest.drugId?.match(guidRegex)) {
            this.backEndRequest.drugNameMessage = undefined;
            this.backEndRequest.drugGroupNameMessage = undefined;
          } else {
            this.backEndRequest.drugNameMessage =
              'یا نام دارو یا نام گروه دارویی را وارد کنید';
            this.backEndRequest.drugGroupNameMessage =
              'یا نام دارو یا نام گروه دارویی را وارد کنید';
            result = false;
          }
        }
      }
    }

    return result;
  }

  public getBackendData() {
    try {
      if (!this.validate()) {
        this.loading = false;
        return;
      }
      this.loading = true;

      const startDate = this.thisMonth.days.find(
        (current) => current.dayOfMonth == 1
      );

      const endDateList = this.thisMonth.days.filter(
        (current) =>
          current.dayOfMonth == 30 ||
          current.dayOfMonth == 31 ||
          current.dayOfMonth == 29
      );

      const endDate = endDateList[endDateList.length - 1];

      if (this.backEndRequest.reportType == null) {
        this.logger.addError('خطایی رخ داده ', false);
        return;
      }

      const backendJson = {
        reportType: parseInt(this.backEndRequest.reportType.toString()),
        drugId: this.backEndRequest.drugId,
        drugGroupId:
          this.backEndRequest.drugGroupId == '-1'
            ? undefined
            : this.backEndRequest.drugGroupId,
        insuranceId: this.backEndRequest.insuranceId,
        startDate: startDate?.equivalentGregorian,
        endDate: endDate.equivalentGregorian,
      };

      switch (this.backEndRequest.reportType.toString()) {
        case CalenderReportType.BuyAndSaleCount.toString():
          this.firstIcon = 'fa-solid fa-cart-plus';
          this.fistClass = 'calender-color-buy';
          this.secondIcon = 'fa-solid fa-shop';
          this.secondClass = 'calender-color-sale';
          break;
        case CalenderReportType.BuyAndSalePrice.toString():
          this.firstIcon = 'fa-solid fa-cart-plus';
          this.fistClass = 'calender-color-buy';
          this.secondIcon = 'fa-solid fa-shop';
          this.secondClass = 'calender-color-sale';
          break;
        case CalenderReportType.CollectiveSale.toString():
          this.firstIcon = 'fas fa-hashtag';
          this.fistClass = 'calender-color-sale-count';
          this.secondIcon = 'fa-solid fa-shop';
          this.secondClass = 'calender-color-sale';
          break;

        case CalenderReportType.SeparateSale.toString():
          this.firstIcon = 'fa-solid fa-user-injured';
          this.fistClass = 'calender-color-patient';
          this.secondIcon = 'fas fa-hand-holding-usd';
          this.secondClass = 'calender-color-insurance';
          break;

        default:
          break;
      }
      let url = `Report/CalenderReport`;

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.renderBackEndActive = true;
            this.mapData(result.data);
          } else {
            this.logger.addBackEndMessage(result);
            this.loading = false;
          }
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public searchNewItem() {
    this.months = this.calendarService.getMonth(true);
    this.chooseMonth(this.thisMonth.monthNumber);
  }

  public mapData(days: any[]) {
    try {
      days.forEach((element) => {
        var foundDay = this.thisMonth.days
          .filter((current) => current.equivalentGregorian != null)
          .find((current) => {
            const trueValue =
              current.equivalentGregorian!.split('T')[0] + 'T00:00:00.000';
            const currentDate = new Date(trueValue);
            const elementDate = new Date(element.propertyValueFirst.value);
            if (currentDate.toDateString() === elementDate.toDateString()) {
              const test =
                'currentDate.toDateString() === elementDate.toDateString()';
            } else {
            }
            return currentDate.toDateString() === elementDate.toDateString();
          });
        if (foundDay != null) {
          foundDay.inputValue = element.propertyValueSecond.value;
          foundDay.outputValue = element.propertyValueThird.value;
        } else {
          this.logger.addError(
            'خطایی رخ داده صفحه را به روز رسانی نمایید ',
            false
          );
        }
      });

      this.renderWeek();
    } catch (error) {
      this.logger.addError(error, false);
    }
    this.loading = false;
  }

  public clearCalender(monthDay: MonthDays) {
    let newList: MonthDays = monthDay;
    newList.days = monthDay.days.map((current) => ({
      dayOfWeekName: current.dayOfWeekName,
      dayOfWeekNumber: current.dayOfWeekNumber,
      dayOfWeekSummaryName: current.dayOfWeekSummaryName,
      dayOfMonth: current.dayOfMonth,
      equivalentGregorian:
        current.equivalentGregorian == undefined
          ? undefined
          : current.equivalentGregorian!.split('T')[0] + 'T00:00:00.000',
      inputValue: current.inputValue,
      outputValue: current.outputValue,
      isHoliday: false,
    }));
    return newList;
  }

  public getHoliday() {
    try {
      const url = `PersianHoliday/GetByMonth?month=${this.thisMonth.monthNumber}&year=${this.thisMonth.year}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.mapHolidays(result.data);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  private mapHolidays(data: any) {
    if (data == null) {
      return;
    }

    data.forEach((element) => {
      var foundDay = this.thisMonth.days
        .filter((current) => current.equivalentGregorian != null)
        .find((current) => {
          const trueValue =
            current.equivalentGregorian!.split('T')[0] + 'T00:00:00.000';
          const currentDate = new Date(trueValue);
          const elementDate = new Date(element.holidayDate);
          return currentDate.toDateString() === elementDate.toDateString();
        });
      if (foundDay == null) {
        this.logger.addError(
          'خطایی رخ داده صفحه را به روز رسانی نمایید ',
          false
        );
        return;
      } else {
        foundDay.isHoliday = true;
      }
    });
    // data.forEach(element => {
    //   var foundedItem=this.thisMonth.days.find((current)=>current.)
    // });
  }
  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          'BuyFactor',
          null,
          undefined,
          'BuyFactor',
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            'BuyFactor' == null ? '' : 'BuyFactor',
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            setTimeout(() => {
              if (this.searchBoxComponent) {
                this.searchBoxComponent.InitPage();
              } else {
                console.error('PCTableComponent not found');
              }
            }, 2);
            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }
}
